import { Util } from "app/utils";
import DateTimeUtil from "app/utils/datatime";
import * as moment from "moment";

export class ConsultRequestSummaryData {
    userId: number;
    userRegDt: Date;
    email: string;
    lastNm: string;
    firstNm: string;

    public get fullName(): string {
        let fullName: string = "";

        if (this.lastNm) {
            fullName += this.lastNm.trim();
        }

        if (this.firstNm) {
            fullName += this.firstNm.trim();
        }

        return fullName;
    }


    jobTp: string;

    public get jobTpText(): string {
        return Util.getJobTpText(this.jobTp);
    }

    userTp: string;
    cmpnyNm: string;
    mobile: string;
    salesManagerUserId: number;
    salesManagerLastNm: string;
    salesManagerFirstNm: string;

    public get salesManagerFullName(): string {
        let fullName: string = "";

        if (this.salesManagerLastNm) {
            fullName += this.salesManagerLastNm.trim();
        }

        if (this.salesManagerFirstNm) {
            fullName += this.salesManagerFirstNm.trim();
        }

        return fullName;
    }

    requestCnt: number;
    processingCnt: number;
    currentRequestCnt: number;
    notConfirmedCnt: number;
    transportCompleteCnt: number;
    hasQuotCnt: number;

    reqNo: string;
    reqDtm: Date;
    quotCnt: number;
    willBeUnAvailableCnt: number;
    
    completeTransDtm: Date;
    lingoStatusCd: number;
    hasMessage: boolean = false;

    public get reqDtmLocalStr() {
        return this.getDtmLocalStr(this.reqDtm);
    }

    public get completeTransDtmLocalStr() {
        return this.getDtmLocalStr(this.completeTransDtm);
    }

    public get userRegDtLocalStr() {
        return this.getDtmLocalStr(this.userRegDt);
    }


    private getDtmLocalStr(dtm: Date): string {
        if (dtm) {
            return moment(dtm).format(DateTimeUtil.dateTimeFormat);
            } else {
            return null;
            }
    }

    public get lingoStatus(): string {
        if (this.lingoStatusCd === 0) {
            return '미요청';
        } else if (this.lingoStatusCd === 1) {
            return '요청';
        } else if (this.lingoStatusCd === 2) {
            return '요청 승인 완료';
        } else if (this.lingoStatusCd === 3) {
            return '최종 승인 완료';
        } else if (this.lingoStatusCd === 99) {
            return '거절';
        } else {
            return '';    
        }        
    }

    constructor(obj? : any) {
        if (obj === null || typeof obj === 'undefined') {
            return;
        }
        this.userId = obj.userId;
        this.userRegDt = obj.userRegDt;
        this.email = obj.email;
        this.lastNm = obj.lastNm;
        this.firstNm = obj.firstNm;
        this.jobTp = obj.jobTp;
        this.userTp = obj.userTp;
        this.cmpnyNm = obj.cmpnyNm;
        this.mobile = obj.mobile;
        this.salesManagerUserId = obj.salesManagerUserId;
        this.salesManagerLastNm = obj.salesManagerLastNm;
        this.salesManagerFirstNm = obj.salesManagerFirstNm;

        this.requestCnt = obj.requestCnt;
        this.processingCnt = obj.processingCnt;
        this.currentRequestCnt = obj.currentRequestCnt;
        this.notConfirmedCnt = obj.notConfirmedCnt;
        this.transportCompleteCnt = obj.transportCompleteCnt;
        this.hasQuotCnt = obj.hasQuotCnt;

        this.reqNo = obj.reqNo;
        this.reqDtm = obj.reqDtm;
        this.quotCnt = obj.quotCnt;
        this.willBeUnAvailableCnt = obj.willBeUnAvailableCnt;

        this.completeTransDtm = obj.completeTransDtm;
        this.lingoStatusCd = obj.lingoStatusCd;
        this.hasMessage = obj.hasMessage;
    }
}


// WEBPACK FOOTER //
// ./src/app/services/sales/model/ConsultRequestSummaryData.ts